import React from "react";

import { DynamicForm } from "src/components/Form";

import { contactFields } from "./fields";

const fields = ({ options, locationOptions }) => ({ t }) => [
  ...contactFields({ t, includeAccountNumber: false }),
  {
    key: "location",
    label: t("forms.services.location", {
      defaultValue: 'Location'
    }),
    placeholder: t("forms.websiteFeedback.location", {
      defaultValue: 'Please choose a location'
    }),
    required: true,
    type: "dropdown",
    inputProps: {
      options: locationOptions
    },
  },
  {
    key: "natureOfFeedback",
    label: t("forms.services.natureOfFeedback", {
      defaultValue: 'Nature of Feedback'
    }),
    placeholder: t("forms.websiteFeedback.natureOfFeedback", {
      defaultValue: 'Please choose a feedback type'
    }),
    required: true,
    type: "dropdown",
    inputProps: {
      options: options
    },
  },
  {
    key: "representative",
    label: t("forms.websiteFeedback.representative", {
      defaultValue: "Name of Representative",
    }),
  },
  {
    key: "comment",
    label: t("forms.websiteFeedback.comment", {
      defaultValue: "Comment/Description",
    }),
    type: "textarea",
    required: true,
    inputProps: {
      minRows: 4,
    },
  },
];

const WebsiteFeedbackForm = ({ moduleKey, options }) => (
  <DynamicForm
    formKey={moduleKey}
    fields={fields(options)}
    defaultSuccessMessageKey="forms.defaultSuccessMessage"
  />
);

export default WebsiteFeedbackForm;



// WEBPACK FOOTER //
// ./src/components/Content/forms/WebsiteFeedbackForm.js